import { render, staticRenderFns } from "./ChoiceQuestion.vue?vue&type=template&id=40dad367"
import script from "./ChoiceQuestion.vue?vue&type=script&lang=js"
export * from "./ChoiceQuestion.vue?vue&type=script&lang=js"
import style0 from "./ChoiceQuestion.vue?vue&type=style&index=0&id=40dad367&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports